import React from 'react';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import { WithStyles } from '@material-ui/core/styles';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { match } from 'react-router-dom';
import debounce from 'lodash/debounce';
// Components
import App from '../../../components/app';
import ErrorMessage from '../../../components/error-message';
import { AutoFill } from '../../../components/field-autofill';
import { AnchorBlock } from '../../../components/anchorBlock';
import { TooltipButton } from '../../../components/tooltip-button';
import { Dialog } from '../../../components/dialog';
import MainLoading from '../../../components/main-loading';
// Modules
import { EmployeeById, IDEmployee, IDRole, RoleDetailById, TParams } from '../../../redux/reducers/api-types';
import { ErrorPayload, selectors as errorSelectors } from '../../../redux/reducers/errors';
import {
    actions as adminActions,
    selectors as adminSelectors,
    types as adminTypes,
} from '../../../redux/reducers/admin';
// Ressources
import withGlobalStyles from '../../../utils/global-styles';
import UserUtils from '../../../utils/userUtils';
import DateUtils from '../../../utils/dateUtils';
import FormUtils from '../../../utils/forms';
import ObjectUtils from '../../../utils/objectUtils';
import StringUtils from '../../../utils/stringUtils';
import { getFindEmployeeURL } from '../../../utils/core-api';
import { clsx } from '../../../utils/htmlUtils';

interface AdminViewProps extends WithTranslation, WithStyles {
    globalClasses: any;
    match: match<TParams>;
    roles: RoleDetailById;
    employees: EmployeeById;
    getAllRolesError: ErrorPayload;
    getEmployeeByIDError: ErrorPayload;
    cudRoleToEmployeeError: ErrorPayload;
    getAllRoles: () => any;
    getEmployeeByID: (id: string) => any;
    addRoleToEmployee: (uuidEmployee: string, uuidRole: string, expires: string) => any;
    mergeRoleBetweenEmployee: (uuidEmployeeSource: string, uuidEmployeeTarget: string, overwrite: boolean) => any;
    removeRoleToEmployee: (uuidEmployee: string, uuidRole: string) => any;
}

class AdminViewPage extends React.Component<AdminViewProps> {
    state = {
        formRole: {} as any,
        idc: '',
    };

    componentDidMount() {
        const { match, roles, getAllRoles, getEmployeeByID } = this.props;
        const id = match.params.id;

        if (id) {
            getEmployeeByID(id);
        }

        if (ObjectUtils.isEmpty(roles)) {
            getAllRoles();
        }
    }

    handleRefresh = (id) => (e) => {
        // this.props.reloadBill(id, {}, () => {
        //     this.tableRef.reload();
        // });
    };

    handleAction = (obj: any, status: string) => () => {
        const id = this.props.match.params.id;

        if (status === adminTypes.REMOVE_ROLE) {
            this.props.removeRoleToEmployee(id, obj.uuid);
        }
    };

    //======================================//
    //=============== Render ===============//
    //======================================//

    renderRoleRows = (employee: IDEmployee) => {
        const { t, globalClasses } = this.props;
        return employee.roles
            .filter((r) => !(new Date(r.expired_at) < new Date()))
            .map((item: IDRole, key) => (
                <TableRow key={item.name}>
                    <TableCell scope="row">{item.name}</TableCell>
                    <TableCell>{item.expires_at ? DateUtils.stringToDate(item.expires_at) : ''}</TableCell>
                    <TableCell scope="row">
                        <div>
                            {/* <Dialog
                            btnTitle={t('common:validate')}
                            description={t('common:editParam', { id: item.name })}
                            customButton={
                                <TooltipButton title={t('common:edit')}>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        className={clsx(globalClasses.btnAutoWidth)}
                                        style={{ marginRight: 8 }}
                                    >
                                        <Icon fontSize="small">edit</Icon>
                                    </Button>
                                </TooltipButton>
                            }
                            onOK={this.handleAction(item, 'edit')} //adminTypes.EDIT
                        /> */}
                            {item.name.startsWith('INT') && (
                                <Dialog
                                    btnTitle={t('common:validate')}
                                    description={t('common:deleteParam', { id: item.name })}
                                    customButton={
                                        <TooltipButton title={t('common:delete')}>
                                            <Button
                                                size="small"
                                                variant="contained"
                                                color="primary"
                                                className={clsx(globalClasses.btnAutoWidth, globalClasses.btnDanger)}
                                            >
                                                <Icon fontSize="small">close</Icon>
                                            </Button>
                                        </TooltipButton>
                                    }
                                    onOK={this.handleAction(item, adminTypes.REMOVE_ROLE)}
                                />
                            )}
                        </div>
                    </TableCell>
                </TableRow>
            ));
    };

    renderRolesView = (employee: IDEmployee): JSX.Element => {
        const { t } = this.props;
        return (
            <Table size="small" aria-label="Table roles">
                <TableHead>
                    <TableRow>
                        <TableCell>{t('matrix.role')}</TableCell>
                        <TableCell>{t('form.expires_at')}</TableCell>
                        <TableCell>{t('common:action')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>{this.renderRoleRows(employee)}</TableBody>
            </Table>
        );
    };

    handleChange = (event) => {
        this.setState(FormUtils.nextSubState(event, this.state, 'formRole'));
    };

    handleSubmitAddRole = (event) => {
        event.preventDefault();
        const id = this.props.match.params.id;
        const { formRole } = this.state;
        if (formRole.role) {
            this.props.addRoleToEmployee(
                id,
                formRole.role,
                formRole.expires_at ? '' + DateUtils.stringToTs(formRole.expires_at) : null,
            );
            this.setState({ formRole: {} });
        }
    };

    handleSubmitCopyRole = (event, overwrite: boolean) => {
        const id = this.props.match.params.id;
        const { idc } = this.state;

        if (idc && id) {
            this.props.mergeRoleBetweenEmployee(idc, id, overwrite);
        }
    };

    debouncedFunction = debounce(this.handleSubmitCopyRole, 500);

    renderAddRole = (employee: IDEmployee): JSX.Element => {
        const { t, globalClasses, roles } = this.props;
        const { formRole } = this.state;
        const values = Object.values(roles);

        return (
            <form onSubmit={this.handleSubmitAddRole}>
                <div style={{ display: 'flex' }}>
                    <FormControl margin="dense" style={{ flex: 1, marginRight: 16, alignSelf: 'flex-end' }}>
                        <Select
                            native
                            id="role"
                            name="role"
                            value={formRole.role}
                            required={true}
                            onChange={this.handleChange}
                        >
                            <option value="">{'Sélectionner un rôle à ajouter'}</option>
                            {values
                                .filter((r) => {
                                    const role = employee.roles.find((er) => er.uuid === r.uuid);
                                    return !role || new Date(role.expired_at) < new Date();
                                })
                                .map((r) => (
                                    <option key={r.uuid} value={r.uuid}>
                                        {r.tag}
                                    </option>
                                ))}
                        </Select>
                    </FormControl>
                    <FormControl key={'expires_at'} style={{ display: 'flex' }}>
                        <div>{t('form.expires_at')}</div>
                        <Input id="expires_at" name="expires_at" type="date" onChange={this.handleChange} />
                    </FormControl>
                    <TooltipButton title={t('common:add')}>
                        <Button
                            size="small"
                            type="submit"
                            variant="contained"
                            color="secondary"
                            style={{ marginLeft: 16 }}
                            className={clsx(globalClasses.btnAutoWidth)}
                        >
                            <Icon fontSize="small">add</Icon>
                        </Button>
                    </TooltipButton>
                </div>
            </form>
        );
    };

    renderCopyRole = (employee: IDEmployee): JSX.Element => {
        const { t, globalClasses } = this.props;

        return (
            <form>
                <div style={{ display: 'flex' }}>
                    <FormControl margin="dense" style={{ flex: 1 }}>
                        <AutoFill
                            datas={{
                                id: 'employee',
                                label: t('form.employee'),
                                minChar: 1,
                                style: { width: '100%', paddingRight: 16 },
                                formData: this.state,
                                variant: 'outlined',
                                onChange: (idc, text) => {
                                    this.setState({ idc });
                                },
                                required: true,
                                isUuid: true,
                                loaderPosition: 'right',
                                api: getFindEmployeeURL(),
                            }}
                        />
                    </FormControl>
                    <TooltipButton title={t('common:add')}>
                        <Button
                            size="small"
                            type="submit"
                            variant="contained"
                            color="secondary"
                            style={{ marginLeft: 8 }}
                            onClick={(e) => {
                                e.preventDefault();
                                this.debouncedFunction(e, false);
                            }}
                            className={clsx(globalClasses.btnAutoWidth)}
                        >
                            {t('common:add')}
                        </Button>
                    </TooltipButton>
                    <TooltipButton title={t('form.overwrite')}>
                        <Button
                            size="small"
                            type="submit"
                            variant="contained"
                            color="secondary"
                            style={{ marginLeft: 8 }}
                            onClick={(e) => {
                                e.preventDefault();
                                this.debouncedFunction(e, true);
                            }}
                            className={clsx(globalClasses.btnAutoWidth, globalClasses.btnDanger)}
                        >
                            {t('form:overwrite')}
                        </Button>
                    </TooltipButton>
                </div>
            </form>
        );
    };

    generateAppHeader = (employee: IDEmployee): any => {
        const { t } = this.props;
        return {
            icon: null,
            title: StringUtils.userFullname(employee),
            anchors: [{ href: '#general_infos', label: t('common:form.general_infos') }],
        };
    };

    render() {
        const { t, employees, match, getAllRolesError, getEmployeeByIDError, cudRoleToEmployeeError } = this.props;
        const id = match.params.id;
        const employee = employees[id];

        return (
            <App hasRole={UserUtils.hasRoleAdminIDOrGod()} header={this.generateAppHeader(employee)}>
                <ErrorMessage payload={getAllRolesError || getEmployeeByIDError} />
                <ErrorMessage payload={cudRoleToEmployeeError} />
                {employee ? (
                    <>
                        <AnchorBlock
                            id="roles_infos"
                            title={t('matrix.roles')}
                            items={this.renderRolesView(employee)}
                        />
                        <AnchorBlock id="roles_add" title={t('form.add')} items={this.renderAddRole(employee)} />
                        <AnchorBlock id="roles_copy" title={t('form.copy')} items={this.renderCopyRole(employee)} />
                    </>
                ) : (
                    <MainLoading center />
                )}
            </App>
        );
    }
}

const AdminViewPageWithStyleAndTranslation = withGlobalStyles(withTranslation(['admin', 'common'])(AdminViewPage));

const mapStateToProps = (state) => ({
    roles: adminSelectors.getRoles(state),
    employees: adminSelectors.getEmployees(state),
    getAllRolesError: errorSelectors.getAllRolesError(state),
    getEmployeeByIDError: errorSelectors.getEmployeeByIDError(state),
    cudRoleToEmployeeError: errorSelectors.cudRoleToEmployeeError(state),
});

const mapDispatchToProps = {
    getEmployeeByID: adminActions.getEmployeeByID,
    addRoleToEmployee: adminActions.addRoleToEmployee,
    mergeRoleBetweenEmployee: adminActions.mergeRoleBetweenEmployee,
    removeRoleToEmployee: adminActions.removeRoleToEmployee,
    getAllRoles: adminActions.getAllRoles,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminViewPageWithStyleAndTranslation);
